import { render, staticRenderFns } from "./TrafficContent.vue?vue&type=template&id=d8bbf0e8&scoped=true"
import script from "./TrafficContent.vue?vue&type=script&lang=js"
export * from "./TrafficContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bbf0e8",
  null
  
)

export default component.exports